import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getAuthentication, isReportIssuer } from '../../api/auth'
import Loading from '../Loading'
import moment from 'moment'

import {deleteOwnReport, getOwnReports, getReportsAsIssuer, getReportsAsOperator } from '../../dummy-data/DUMMYDATA'
import { withRouter } from 'react-router'

import Logo from '../Logo'
import { formatNumber } from '../../utils/utils'

function encodeQueryData(data) {
  const ret = []

  for (let d in data) {
    let value = data[d]

    if (Array.isArray(value)) {
      value = value.join(',')
    }
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
  }
  return ret.join('&')
}

class ReportsView extends Component {

  constructor(props) {
    super(props)
    this.state = {
      monthlyReports: undefined,
      ownReports: undefined
    }
  }

  componentDidMount() {

    // Get monthly reports
    if (isReportIssuer()) {
      getReportsAsIssuer().then(res => {
        this.setState({monthlyReports: res})
      })

    } else {
      getReportsAsOperator(getAuthentication().entity).then(res => {
        this.setState({monthlyReports: res})
      })
    }

    // Get own reports
    getOwnReports().then(res => {
      this.setState({ownReports: res})
    })

  }

  deleteOwnReport = (rp) => {
    // TODO Confirmation dialog
    deleteOwnReport(rp.id).then(res => {
      this.setState({ownReports: res})
    })
  }


  render() {

    return (
      <div>
        <Logo small/>

      
        <div className='section mt-0 pt-0'>

          <section className='container mt-0 mb-6'>
            <div className="container sie-title-container mb-6">
              <h4 className="title">Publicações Mensais</h4>
              <h5 className="subtitle">Relatórios emitidos mensalmente</h5>
            </div>

            {this.state.monthlyReports ?
              <MonthlyReportTable monthlyReports={this.state.monthlyReports} history={this.props.history}/>
              : 
              <Loading/>
            }          
          </section>
        
          <section className='container mt-6 mb-3'>
            <div className="container sie-title-container mb-6">
              <h4 className="title">Relatórios {getAuthentication().entity}</h4>
              <h5 className="subtitle">Relatórios guardados no <a onClick={() => this.props.history.push('/explorer')}>
            Explorador de Leituras</a></h5>
            </div>

            {this.state.ownReports ?
              <OwnReportTable reports={this.state.ownReports} onDeleteReport={this.deleteOwnReport} history={this.props.history}/>
              : 
              <Loading/>
            }      

          </section>

          {/* 
        <section className='container mt-6 mb-3'>
          <div className="container sie-title-container">
            <h4 className="title">Publicações {getAuthentication().entity}</h4>
            <h5 className="subtitle">Relatórios emitidos pela {getAuthentication().entity}</h5>
          </div>
        </section> */}
        </div>
      </div>
    )
  }
}


class OwnReportTable extends Component {


  navigateToOwnReport = (report) => {
    // onClick={() => this.props.history.push(`/report/${this.props.reportGroup.id}`)}>
    // exploreReadings = () => {

    // const filters = report.filters

    // const params = {
    //   fromDt: filters.fromDt,
    //   toDt: filters.fromDt,
    //   granularity: filters.granularity,
    // }

    // for (const key of Object.keys(filters.dataFilters)) {
    //   params[key] = filters.dataFilters[key]
    // }

    // const urlQuery = encodeQueryData(params)

    // this.props.history.push(`/explorer?${urlQuery}`)
    this.props.history.push(`/explorer?${encodeURIComponent('ownReportId') + '=' + encodeURIComponent(report.id)}`)

  }

  deleteReport = (report) => {
    this.props.onDeleteReport(report)
  }

  render() {

    const rps = this.props.reports

    return(
      <div className="b-table">
        <div className="table-wrapper has-mobile-cards">
          <table className="table is-fullwidth is-hoverable is-fullwidth"> 
            <thead>
              <tr>
                <th style={{width: '15vw'}}>Relatório</th>
                <th style={{width: '15vw'}}>Data</th>
                <th style={{width: '15vw'}}>Criado Por</th>
                <th className="has-text-centered" style={{width: '5vw'}}>Ver</th>
                <th className="has-text-centered" style={{width: '5vw'}}>Eliminar</th>
              </tr>
            </thead>

            <tbody>
              {rps.length > 0 ? rps.map((rp) =>

                <tr key={rp.id}>

                  <td data-label="Relatório" style={{textTransform: 'capitalize', fontWeight: 'bold'}}>{rp.name}</td>
                  <td data-label="Criado">
                    <small className="has-text-grey is-abbr-like">{moment(rp.createdAt).format('YYYY-MM-DD HH:mm')}</small>
                  </td>
                  <td data-label="Criado Por">{rp.createdBy}</td>

                  <td className="is-actions-cell ">
                    <div className="buttons is-centered">
                      <button className="button is-small is-primary" type="button" 
                        onClick={() => this.navigateToOwnReport(rp)}>
                        
                        <FontAwesomeIcon icon="eye"></FontAwesomeIcon>
                      </button>
                    </div>
                  </td>
                  <td className="is-actions-cell ">
                    <div className="buttons is-centered">
                      <button className="button is-small is-danger" type="button" 
                        onClick={() => this.deleteReport(rp)}>                        
                        <FontAwesomeIcon icon="trash"></FontAwesomeIcon>
                      </button>
                    </div>
                  </td>

                </tr>
              ) : <tr className='is-empty'>
                <td colSpan="12">
                  <section className="section">
                    <div className="has-text-grey has-text-centered">
                      <p>Sem relatórios para mostrar.&hellip;</p>
                    </div>
                  </section>
                </td>
              </tr>                                
              }                                   
            </tbody> 
          </table>
        </div> 
      </div>   
    )


  }
}



class MonthlyReportTable extends Component {

  constructor(props) {
    super(props)

    const paginationYears = [...new Set(this.props.monthlyReports.map(mr => mr.year))].sort((a, b) => a - b)

    this.state = {
      currentYear: paginationYears[paginationYears.length - 1],
      paginationYears: paginationYears
    }
  }

  onPaginationYearChanged = (year) => {
    this.setState({currentYear: year})
  }


  render() {

    const showReports = this.props.monthlyReports.filter(mr => mr.year === this.state.currentYear)

    return(
      <>

        <YearPagination currentYear={this.state.currentYear} years={this.state.paginationYears} onYearChanged={this.onPaginationYearChanged}/>

        <div className="b-table">
          <div className="table-wrapper has-mobile-cards">
            <table className="table is-fullwidth is-hoverable is-fullwidth"> 
              <thead>
                <tr>
                  <th className="is-chevron-cell has-text-centered" style={{width: '2vw'}}></th>
                  <th style={{width: '15vw'}}>Relatório</th>
                  <th style={{width: '15vw'}}>Consumo (kWh)</th>
                  <th style={{width: '15vw'}}>Frenagem (kWh)</th>

                  {/* <th style={{width: '10vw'}}>Variação</th> */}

                  {isReportIssuer() && 
                    <th style={{width: '20vw'}}>Publicado</th>
                  }
                  <th style={{width: '10vw'}}>Criado</th>

                  <th className="has-text-centered" style={{width: '5vw'}}>Ver</th>
                  {/* <th className="has-text-centered" style={{width: '5vw'}}>PDF</th> */}
                </tr>
              </thead>

              <tbody>
                {showReports.length > 0 ? showReports.map((reportGroup) =>
                  <MonthlyReportTableRow key={reportGroup.id} reportGroup={reportGroup} history={this.props.history}/>
                ) : <tr className='is-empty'>
                  <td colSpan="12">
                    <section className="section">
                      <div className="has-text-grey has-text-centered">
                        <p>Sem relatórios &hellip;</p>
                      </div>
                    </section>
                  </td>
                </tr>                                
                }                                   
              </tbody> 
            </table>
          </div> 
        </div>   

      </>   
    )
  }
}





class MonthlyReportTableRow extends Component {

  constructor(props) {
    super(props)
    this.state = { expanded: false }
  }

  render() {
    
    const reportGroupName = moment(`${this.props.reportGroup.year}-${String(this.props.reportGroup.month+1).padStart(2, '0')}-01 00:00:00`).format('MMMM - YYYY')

    const hasSubReports = Object.prototype.hasOwnProperty.call(this.props.reportGroup, 'reports')
    
    let publishedCount, publishProgress
    if (hasSubReports) {
      publishedCount = this.props.reportGroup.reports.filter(r => r.publishedAt).length
      publishProgress =  publishedCount / this.props.reportGroup.reports.length * 100
    }
    let progressColor = publishProgress === 100 ? 'primary' : 'warning'

    return (
      <>
        <tr  onClick={() => this.setState({ expanded: !this.state.expanded })}>

          <td className="is-chevron-cell has-text-centered">
            {hasSubReports &&
              <a className="has-text-primary" role="button" onClick={() => this.setState({ expanded: !this.state.expanded })}>
                <FontAwesomeIcon icon={this.state.expanded ? 'angle-right' : 'angle-down'}></FontAwesomeIcon>
              </a>
            }
          </td>

          <td data-label="Relatório" style={{textTransform: 'capitalize', fontWeight: 'bold'}}>{reportGroupName}</td>


          <td data-label="Consumo (MWh)">
            <span>
              {formatNumber(this.props.reportGroup.consumptionTotal, 0)}
            </span>
            <span>
              {this.props.reportGroup.consumptionVar ? <>
            &nbsp;&nbsp;&nbsp;
                <span className={`${this.props.reportGroup.consumptionVar >= 0 ? 'has-text-danger' : 'has-text-success'} is-size-7`}>
                  <FontAwesomeIcon icon={this.props.reportGroup.consumptionVar >= 0 ? 'caret-up' : 'caret-down'}></FontAwesomeIcon>
              &nbsp;
                  {formatNumber(this.props.reportGroup.consumptionVar * 100)} %
                </span>
              </> : <div></div>
              }
            </span>
          </td>
          <td data-label="Frenagem (MWh)">
            <span>
              {formatNumber(this.props.reportGroup.brakingTotal, 0)}
            </span>
            <span>
              {this.props.reportGroup.brakingVar ? <>
            &nbsp;&nbsp;&nbsp;
                <span className={`${this.props.reportGroup.brakingVar >= 0 ? 'has-text-success' : 'has-text-danger'} is-size-7`}>
                  <FontAwesomeIcon icon={this.props.reportGroup.brakingVar >= 0 ? 'caret-up' : 'caret-down'}></FontAwesomeIcon>
              &nbsp;
                  {formatNumber(this.props.reportGroup.brakingVar * 100)} %
                </span>
              </> : <div></div>
              }
            </span>
          </td>

          {isReportIssuer() && hasSubReports &&
            <td data-label="Publicado" className="is-progress-cell">
              <progress max="100" className={`progress is-small is-${progressColor}`} value={publishProgress}>{publishProgress} </progress>
            </td>
          }

          <td data-label="Criado">
            <small className="has-text-grey is-abbr-like">{moment(this.props.reportGroup.createdAt).format('YYYY-MM-DD')}</small>
          </td>

          <td className="is-actions-cell ">
            <div className="buttons is-centered">
              <button className="button is-small is-primary" type="button" 
                onClick={() => this.props.history.push(`/report/${this.props.reportGroup.id}`)}>
                <FontAwesomeIcon icon="eye"></FontAwesomeIcon>
              </button>
            </div>
          </td>

          {/* <td className="is-actions-cell ">
            <div className="buttons is-centered">
              <button className="button is-small is-primary" type="button">
                <FontAwesomeIcon icon="download"></FontAwesomeIcon>
              </button>
            </div>
          </td> */}

        </tr>

        {(hasSubReports && this.state.expanded) && 
          <tr className="detail" >
        
            <td colSpan="12" style={{padding: '0px', paddingTop: '10px', paddingBottom: '20px'}}>

              <table className="table is-fullwidth is-hoverable is-fullwidth" style={{
                borderBottom: '3px solid lightgray', 
                borderTop: '2px solid lightgray', 
                // borderLeft: '3px solid lightgray',
                // borderRight: '2px solid lightgray',

              }}> 
                <tbody>

                  {this.props.reportGroup.reports.map((report) => 
                    <ReportRow key={report.id} report={report} history={this.props.history}/>
                  )}
                        
                </tbody> 
              </table>

            </td>
          </tr>
        }
      </>
    )
  }
}


class ReportRow extends Component {

  render() {
    const report = this.props.report

    return (
      <>
        <tr style={{backgroundColor:'#f2f2f2'}}>

          <th className="is-chevron-cell has-text-centered" style={{width: '2vw'}}></th>

          <td  style={{width: '2vw'}}></td>
          <td data-label="Relatório" style={{textTransform: 'capitalize', fontWeight: 'bold', width: '14vw'}}>{report.operatorName}</td>

          <td style={{width: '15vw'}}>
            <span className='is-size-6'>
              {formatNumber(report.consumptionTotal, 0)}</span>
            <span>

              {report.consumptionVar ? <>  &nbsp;
                <span className={`${report.consumptionVar >= 0 ? 'has-text-danger' : 'has-text-success'} is-size-7`}>
                  <FontAwesomeIcon icon={report.consumptionVar >= 0 ? 'caret-up' : 'caret-down'}></FontAwesomeIcon> &nbsp;
                  {formatNumber(report.consumptionVar * 100)} %
                </span>
              </> : <div></div>
              }

            </span>
          </td>
          {/* 
          <td style={{width: '10vw'}}>
            {report.consumptionLastMonthVar ? <>  &nbsp;
              <span className={`${report.consumptionLastMonthVar >= 0 ? 'has-text-danger' : 'has-text-success'} is-size-7`}>
                <FontAwesomeIcon icon={report.consumptionLastMonthVar >= 0 ? 'caret-up' : 'caret-down'}></FontAwesomeIcon> &nbsp;
                {(report.consumptionLastMonthVar * 100).toFixed(1)} %
              </span>
            </> : <div></div>
            }
          </td> */}


          <td style={{width: '15vw'}}>
            <span className='is-size-6'>
              {formatNumber(report.brakingTotal, 0)}</span>
            <span>

              {report.brakingVar ? <>  &nbsp;
                <span className={`${report.brakingVar >= 0 ? 'has-text-danger' : 'has-text-success'} is-size-7`}>
                  <FontAwesomeIcon icon={report.brakingVar >= 0 ? 'caret-up' : 'caret-down'}></FontAwesomeIcon> &nbsp;
                  {formatNumber(report.brakingVar * 100)} %
                </span>
              </> : <div></div>
              }

            </span>
          </td>

          <td data-label="Publicado"  style={{width: '20vw'}} className='has-text-centered'>
            {report.publishedAt && 
              <span className=' has-text-primary' style={{width: '10vw'}}>Publicado</span>
            }
            {!report.publishedAt && 
              <span className='has-text-warning' style={{width: '10vw'}}>Aguarda Validação</span>
            }
          </td>

          <td style={{width: '10vw'}}></td>

          <td className="is-actions-cell " style={{width: '5vw'}}>
            <div className="buttons is-centered">
              <button 
                onClick={() => this.props.history.push(`/report/${this.props.report.id}`)}
                className="button is-small is-primary" type="button">
                <FontAwesomeIcon icon="eye"></FontAwesomeIcon>
              </button>
            </div>
          </td>

          {/* 
          <td className="is-actions-cell " style={{width: '5vw'}}>
            <div className="buttons is-centered">
              <button className="button is-small is-primary" type="button">
                <FontAwesomeIcon icon="download"></FontAwesomeIcon>
              </button>
            </div>
          </td> */}
        </tr>
      </>
    )
  }
}

class YearPagination extends Component {

  constructor(props) {
    super(props)

    this.state = {
      currentYear: this.props.currentYear,
      firstYear: this.props.years[0],
      lastYear: this.props.years[this.props.years.length - 1],
    }
  }

  onYearChanged = (year) => {
    this.setState({currentYear: year})
    this.props.onYearChanged(year)
  }

  render() {

    const VISIBLE_RADIUS = 1
    const visibleYears = []
      
    let start = Math.max(this.state.currentYear - VISIBLE_RADIUS, this.state.firstYear)
    let end = Math.min(this.state.currentYear + VISIBLE_RADIUS, this.state.lastYear)

    if (start < this.state.firstYear) {
      start = this.state.firstYear
      end = start + VISIBLE_RADIUS * 2
    }

    if (end > this.state.lastYear) {
      start = this.state.lastYear - VISIBLE_RADIUS * 2
      end = this.state.lastYear
    }

    if (VISIBLE_RADIUS * 2 + 1 > this.state.lastYear) {
      start = this.state.firstYear
      end = this.state.lastYear
    }

    for (let i = start; i <= end; i++) {
      visibleYears.push(i)
    }

    const yearPage = (year, onChange) => (
      <li key={year}>
        <a 
          className={`pagination-link ${(this.state.currentYear === year || (year === this.state.firstYear && !this.state.currentYear)) && 'is-current'}`}
          aria-label={`Go to year ${year}`}
          aria-current={year === this.state.currentYear && 'page'}
          onClick={() => onChange(year)}
        >
          {year}
        </a>
      </li>
    )

    const ellipses = (key) => <li key={key}><span className="pagination-ellipsis">&hellip;</span></li>

    const yearComponents = []

    if (visibleYears[0] >= this.state.firstYear + 1) {
      yearComponents.push(yearPage(this.state.firstYear, this.onYearChanged))
  
      if (visibleYears[0] !== this.state.firstYear + 1) {
        yearComponents.push(ellipses('elips1'))
      }
    }

    visibleYears.map(year =>
      yearComponents.push(yearPage(year, this.onYearChanged))
    )

    if (this.state.currentYear <= this.state.lastYear - VISIBLE_RADIUS - 1 && (this.state.firstYear + visibleYears.length) < this.state.lastYear) {

      if (this.state.currentYear < this.state.lastYear - VISIBLE_RADIUS - 1) {
        yearComponents.push(ellipses('elips2'))
      }
    
      yearComponents.push(yearPage(this.state.lastYear, this.onYearChanged))
    }

    return(
      <nav className="pagination is-centered" role="navigation" aria-label="pagination">

        <a 
          className="pagination-previous" 
          disabled={this.state.currentYear === this.state.firstYear}
          onClick={() => this.state.currentYear !== this.state.firstYear && this.onYearChanged(this.state.currentYear - 1)}
        >Anterior</a>

        <a 
          className="pagination-next" 
          disabled={this.state.currentYear === this.state.lastYear}
          onClick={() => this.state.currentYear !== this.state.lastYear && this.onYearChanged(this.state.currentYear + 1)}
        >Seguinte</a>

        <ul className="pagination-list">
          {yearComponents}
        </ul>
      </nav>

    )
  }
}

export default withRouter(ReportsView)